import apiService from './ApiService';

// Servicio para endpoints de Colegios, Materias y asignaciones
class ColegioApiService {
  async getColegios() {
    return apiService.get('/colegios');
  }

  async getColegiosActivos() {
    return apiService.get('/colegios/activos');
  }

  async getMisColegios() {
    return apiService.get('/colegios/mis');
  }

  async getColegioById(id) {
    return apiService.get(`/colegios/${id}`);
  }

  async getColegioByIdAdmin(id) {
    return apiService.get(`/colegios/${id}/admin`);
  }

  async getColegioApiKey(id) {
    return apiService.get(`/colegios/${id}/apikey`);
  }

  async getOpenAIAssistantKeys() {
    return apiService.get('/colegios/openai-assistant-keys');
  }

  async getOpenAIAssistantModels() {
    return apiService.get('/colegios/openai-assistant-models');
  }

  async getOpenAIAssistantConfigs(colegioId, options = {}) {
    const params = new URLSearchParams();
    if (options.incluirInactivos !== undefined) {
      params.append('incluirInactivos', String(Boolean(options.incluirInactivos)));
    }
    const qs = params.toString();
    return apiService.get(`/colegios/${colegioId}/openai-assistants-config${qs ? `?${qs}` : ''}`);
  }

  async createOpenAIAssistantConfig(colegioId, payload) {
    return apiService.post(`/colegios/${colegioId}/openai-assistants-config`, payload);
  }

  async updateOpenAIAssistantConfig(colegioId, id, payload) {
    return apiService.put(`/colegios/${colegioId}/openai-assistants-config/${id}`, payload);
  }

  async deleteOpenAIAssistantConfig(colegioId, id) {
    return apiService.delete(`/colegios/${colegioId}/openai-assistants-config/${id}`);
  }

  async getOpenAIAssistantUsage(colegioId, options = {}) {
    const params = new URLSearchParams();
    if (options.assistantConfigId) params.append('assistantConfigId', options.assistantConfigId);
    if (options.from) params.append('from', options.from);
    if (options.to) params.append('to', options.to);
    const qs = params.toString();
    return apiService.get(`/colegios/${colegioId}/openai-assistants-config/usage${qs ? `?${qs}` : ''}`);
  }

  async getFeatureFlagsByColegio(id) {
    return apiService.get(`/colegios/${id}/feature-flags`);
  }

  async updateFeatureFlagByColegio(id, nombre, activo) {
    return apiService.put(`/colegios/${id}/feature-flags/${encodeURIComponent(nombre)}`, { activo });
  }

  async getConsumosTokensByColegio(id, options = {}) {
    const params = new URLSearchParams();
    if (options.from) params.append('from', options.from);
    if (options.to) params.append('to', options.to);
    const qs = params.toString();
    return apiService.get(`/colegios/${id}/consumos-tokens${qs ? `?${qs}` : ''}`);
  }

  async getStatsByColegio(id, { from, to } = {}) {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const qs = params.toString();
    return apiService.get(`/colegios/${id}/estadisticas${qs ? `?${qs}` : ''}`);
  }

  async getGlobalStats({ from, to, colegioId } = {}) {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    if (colegioId) params.append('colegioId', colegioId);
    const qs = params.toString();
    return apiService.get(`/colegios/estadisticas-generales${qs ? `?${qs}` : ''}`);
  }

  async getLoginStatsByColegio(id, options = {}) {
    return this.getStatsByColegio(id, options);
  }

  async getColegioByNombreUrl(nombreUrl) {
    return apiService.getPublic(`/colegios/por-nombre-url/${encodeURIComponent(nombreUrl)}`);
  }

  async createColegio(payload) {
    return apiService.post('/colegios', payload);
  }

  async updateColegio(id, payload) {
    return apiService.put(`/colegios/${id}`, payload);
  }

  async updateColegioActivo(id, activo) {
    return apiService.put(`/colegios/${id}/activo`, { activo });
  }

  async resetColegioSchema(id, confirmacionNombreColegio) {
    return apiService.post(`/colegios/${id}/reset-schema`, { confirmacionNombreColegio });
  }

  async deleteColegio(id) {
    return apiService.delete(`/colegios/${id}`);
  }

  async getMaterias() {
    return apiService.get('/Materias');
  }

  async createMateria(payload) {
    return apiService.post('/Materias', payload);
  }

  async updateMateria(id, payload) {
    return apiService.put(`/Materias/${id}`, payload);
  }

  async deleteMateria(id) {
    return apiService.delete(`/Materias/${id}`);
  }

  async assignUserToColegio(colegioId, payload) {
    return apiService.post(`/Colegio/${colegioId}/usuarios`, payload);
  }

  async assignUserToArea(areaId, payload) {
    return apiService.post(`/Area/${areaId}/usuarios`, payload);
  }
}

const colegioApiService = new ColegioApiService();

export default colegioApiService;
